import { validateAtLeastOne } from '../commonValidations';

export const validateFlexibleWeddingDateField = (value: string[]) => validateAtLeastOne(value);
